import angular from "angular";
import uiRouter from "angular-ui-router";
import "ngstorage";
import auth from "../../services/auth.js";
import events from "../../services/events.js";
import security from "../../services/security.js";
import env from "../../services/env.js";
import companies from "../../services/companies.js";

class DirectpayController {
    constructor(
        $http,
        $localStorage,
        $state,
        AuthService,
        EventsService,
        SecurityService,
        EnvService,
        CompaniesService,
        $timeout,
        $rootScope,
        $scope,
        $stateParams, ProfilesService
    ) {
        this.name = "directpay";
        $localStorage.activeStateName = "directpay";

        if (!AuthService.isLoggedIn()) {
            $state.go("signin");
            return;
        }

        this.$http = $http;
        this.$profiles = ProfilesService;
        this.$localStorage = $localStorage;
        this.$state = $state;
        this.$rootScope = $rootScope;
        this.$auth = AuthService;
        this.$events = EventsService;
        this.$security = SecurityService;
        this.$env = EnvService;
        this.$companies = CompaniesService;
        this.$timeout = $timeout;
        this.bulk_pay_link_value = "Confirm";
        this.currentPageNumber = 1;
        this.payReceiptsArray = [];
        this.paymentMethodSelected = false;
        this.pages = [];
        this.$stateParams = $stateParams;
        this.fid = null;
        this.making_bulk_pay = false;
        this.bulk_pay_data = {};
        this.currentUser = this.$auth.getUserData();
        this.creditCards = this.$auth.getUserData().company.undeletedPaymentInfos;
        this.paymentInfos = this.$auth.getUserData().company.undeletedPaymentInfos;
        this.paymentMethods = this.$auth.getUserData().company.undeletedPaymentInfos;
        this.selectedCard = null;
        this.directPaymentReceiptList = [];
        this.paymentStatus = 0;
        this.paymentMessage = "";
        this.$scope = $scope;
        this.offsetForPagination = 20;
        this.cardsArray = [];
        this.banksArray = [];
        this.getLatestInfo();
        this.pullLatestPaymentInfo();
        //this.organizePaymentInfo();
        this.payments_loaded = false;
        this.show = true;
        this.remain_loading_count = 0;
        this.navOptions = [];

        if (this.$state.current.name === "directpay") {
            this.page = "directpay";
            this.navOptions = [
                {type: "direct-pay", isActive: "active", value: "Direct Pay", icon: "fas fa-comment-dollar"},
                {type: "bulk-pay", isActive: "", value: "Bulk Pay", icon: "fas fa-users"},
            ];
        } else {
            this.navOptions = [
                {type: "direct-pay", isActive: "", value: "Direct Pay", icon: "fas fa-comment-dollar"},
                {type: "bulk-pay", isActive: "active", value: "Bulk Pay", icon: "fas fa-users"},
            ];
            this.page = "bulkpay";
        }

        this.payJobblerInfo = {
            email: "",
            amount: null,
            noteForReceipt: null,
        };

        this.totalPayments = this.currentUser.company.totalNumberOfInvoiceFiles;

        var _this = this;

        if (_this.currentUser.company.totalNumberOfInvoiceFiles) {
            var pageArray = [];
            for (var i = 0; i < Math.ceil(_this.currentUser.company.totalNumberOfInvoiceFiles / 20); i++) {
                pageArray.push(i + 1);
                _this.pages = pageArray;
            }
        }

        _this.UpdatedCreditCardListener = _this.$rootScope.$on("UpdatedCreditCard", function () {
            _this.$auth.reloadCurrentUser();
            _this.$timeout(function () {
                _this.currentUser = _this.$auth.getUserData();
                _this.creditCards = _this.currentUser.company.paymentInfos;
                _this.paymentInfos = _this.currentUser.company.paymentInfos;
                _this.cardsArray = [];
                _this.banksArray = [];
                //_this.organizePaymentInfo();
            }, 3000);
        });

        _this.$scope.$on("$destroy", _this.UpdatedCreditCardListener);
        _this.getDirectPayReceipts();

        //_this.formatPaymentInfoForPage(this.paymentMethods);

        _this.$timeout(function () {
            _this.remain_loading_count = 0;
        }, 1000);

        console.log("current user");
        console.dir(_this.currentUser);

    }

    selectCardInfo(selectedCard, $event) {
        this.selectedCard = selectedCard;
        this.payType = "card";
    }

    selectBankInfo(selectedBank, $event) {
        this.selectedBank = selectedBank;
        this.payType = "bank";
    }

    cancelPay() {
        var _this = this;
        _this.$timeout(function () {
            jQuery("#modal-pay-jobbler .modal-header button.close").trigger("click");
        });
    }

    formatPaymentCost(receipts) {
        var _this = this;
        receipts.forEach(function (receipt, index) {
            if (receipt.payment) {
                receipt.adjustedAmount = (receipt.payment[0].amount * (1 + _this.currentUser.company.defaultPlan.companyFeePct)) / 100;
                if (index === 0) {
                    _this.formatMessageForConfirmation(receipt);
                }
            } else {
                receipts.splice(index, 1);
            }
        });
        _this.loading_invoices = false;
    }

    directPayJobblerNew(isValid) {
        if (isValid) {
            alert("our program is mad lit");
        } else {
            alert("we have an error!");
        }
    }

    setCompanyCharge() {
        if (this.payJobblerInfo.amount) {
            let fee = (this.payJobblerInfo.amount * (1 + this.currentUser.company.defaultPlan.companyFeePct)) - this.payJobblerInfo.amount;
            this.payJobblerInfo.companyAmount = this.payJobblerInfo.amount * (1 + this.currentUser.company.defaultPlan.companyFeePct);
            this.payJobblerInfo.platformFee = fee;
        } else {
            this.payJobblerInfo.companyAmount = 0;
        }
    }

    setListItemData() {
        var _this = this;

        let pay_data = {};
        pay_data.jobbler = _this.payJobblerInfo.email;
        pay_data.amount = _this.payJobblerInfo.companyAmount;
        pay_data.display_amount = _this.payJobblerInfo.amount * (1 + _this.currentUser.company.defaultPlan.companyFeePct);
        if (!_this.currentUser.company.payByInvoice) {
            pay_data.token = _this.selectedPaymentMethod.stripeId;
            if (_this.selectedPaymentMethod.bankName) {
                pay_data.token_type = "bank";
                //_this.bulk_pay_data.token_type = "bank";
            } else {
                pay_data.token_type = "card";
                //_this.bulk_pay_data.token_type = "card";
            }
            pay_data.last4 = _this.selectedPaymentMethod.last4;
        }
        pay_data.fee = (_this.currentUser.company.defaultPlan.companyFeePct * _this.payJobblerInfo.amount) / 100;

        _this.pay_data = pay_data;
    }

    directPayJobbler(formData) {

        this.paymentStatus = 0;
        this.paymentMessage = "";
        this.paymentError = false;

        var status = this.validatePayJobbler();
        var _this = this;

        if (formData && status.status) {
            _this.setListItemData();
            jQuery("#direct-pay-completed").modal();
            return;
        }

        _this.$timeout(function () {
            jQuery("#direct-pay-completed .modal-header button.close").trigger("click");
        }, 100);

        _this.remain_loading_count = 5;

        if (status.status) {
            var reqPayJobbler = null;

            if (_this.currentUser.company.payByInvoice) {
                reqPayJobbler = {
                    method: "POST",
                    url: _this.$env.getAPIEndPoint() + "jbl/v1/stripe/transfer?format=json",
                    headers: {
                        "Content-Type": "application/json",
                        Authorization: "Bearer " + _this.currentUser.access_token,
                    },
                    data: {
                        transfers: [
                            {
                                recipient: _this.payJobblerInfo.email,
                                amount: parseInt(_this.payJobblerInfo.amount * 100),
                                note: _this.payJobblerInfo.noteForReceipt,
                            },
                        ],
                    },
                };
            } else {
                if (_this.selectedPaymentMethod.payType === "bank") {
                    reqPayJobbler = {
                        method: "POST",
                        url: _this.$env.getAPIEndPoint() + "jbl/v1/stripe/transfer?format=json",
                        headers: {
                            "Content-Type": "application/json",
                            Authorization: "Bearer " + _this.currentUser.access_token,
                        },
                        data: {
                            bank: _this.selectedPaymentMethod.stripeId,
                            transfers: [
                                {
                                    recipient: _this.payJobblerInfo.email,
                                    amount: parseInt(_this.payJobblerInfo.amount * 100),
                                    note: _this.payJobblerInfo.noteForReceipt,
                                },
                            ],
                        },
                    };
                } else {
                    reqPayJobbler = {
                        method: "POST",
                        url: _this.$env.getAPIEndPoint() + "jbl/v1/stripe/transfer?format=json",
                        headers: {
                            "Content-Type": "application/json",
                            Authorization: "Bearer " + _this.currentUser.access_token,
                        },
                        data: {
                            card: _this.selectedPaymentMethod.cardToken,
                            transfers: [
                                {
                                    recipient: _this.payJobblerInfo.email,
                                    amount: parseInt(_this.payJobblerInfo.amount * 100),
                                    note: _this.payJobblerInfo.noteForReceipt,
                                },
                            ],
                        },
                    };
                }
            }

            _this.$http(reqPayJobbler).then(
                function (response) {

                    var resp = response;

                    if (response.data.status === "error" || response.data[0].status === "error") {
                        _this.$timeout(function () {
                            jQuery("#modal-card-declined-modal").modal();
                            _this.remain_loading_count = 1;
                            _this.paymentMessage = response.data[0].message;
                        }, 100);

                        return;
                    } else {
                        if (response.data[0].invalidUsers) {
                            _this.$timeout(function () {
                                _this.paymentMessage = "The user " + response.data[0].invalidUsers[0].recipient + " does not exist";
                                _this.paymentStatus = 2;
                                _this.isInvalidUser = true;
                                _this.remain_loading_count = 5;
                                jQuery("#modal-card-error").trigger("click");
                            });
                        } else if (response.data[0].missinPaymentnfo) {
                            var invalidUser = response.data[0].missinPaymentnfo[0].recipient;

                            _this.$timeout(function () {
                                _this.paymentMessage =
                                    "The user " + invalidUser + " has not setup their bank account. Transaction can not be completed.";
                                _this.paymentStatus = 2;
                                _this.isInvalidUser = true;
                                _this.remain_loading_count = 1;
                                jQuery("#modal-card-error").trigger("click");
                            });
                        } else {
                            try {
                                var user = null;

                                var payloop = function (value) {
                                    _this.$timeout(function () {
                                        user = _this.$auth.reloadCurrentUser();

                                        if (value === 0) {
                                            _this.$companies.getDirectPaymentReceipts(20, _this.fid).then(
                                                function (response) {
                                                    _this.formatPaymentCost(response.data, resp);
                                                    _this.directPaymentReceiptList = response.data;
                                                    _this.remain_loading_count = 1;

                                                    _this.$timeout(function () {
                                                        _this.paymentMessage = "Your payment was successful.";
                                                        _this.paymentStatus = 10;
                                                        _this.payJobblerInfo.email = null;
                                                        _this.validEmail = false;
                                                        _this.error_with_email = null;
                                                        _this.successfulEmail = null;
                                                        _this.payJobblerInfo.amount = null;
                                                        _this.payJobblerInfo.companyAmount = null;
                                                        _this.payJobblerInfo.platformFee = null;
                                                        _this.payJobblerInfo.noteForReceipt = null;
                                                        _this.isInvalidUser = false;
                                                        _this.paymentStatus = 1;
                                                        $("#modal-card-error-modal").modal();
                                                    });
                                                },
                                                function (response) {
                                                    _this.remain_loading_count = 1;
                                                    return;
                                                    _this.$timeout(function () {
                                                        jQuery("#show-application-alert").trigger("click");
                                                    }, 100);
                                                }
                                            );
                                        } else {
                                            return payloop(value - 1);
                                        }
                                    }, 2000);
                                };

                                payloop(2);

                            } finally {
                                _this.paymentStatus = 1;
                                _this.paymentMessage = "The jobbler was successfully paid.";
                                _this.$timeout(function () {
                                    jQuery("#modal-pay-jobbler .modal-header button.close").trigger("click");
                                });
                            }
                        }
                    }
                },
                function (response) {
                    _this.$timeout(function () {
                        _this.remain_loading_count = 1;
                        jQuery("#modal-pay-jobbler .modal-header button.close").trigger("click");
                        jQuery("#show-application-alert").trigger("click");
                    }, 100);
                }
            );
        } else {
            _this.$timeout(function () {
                _this.paymentError = status.message;
                _this.paymentStatus = 2;
                _this.paymentMessage = status.message;
                //jQuery('#modal-card-error').trigger('click');
            });
        }
    }

    validatePayJobbler() {

        var retObj = {};

        retObj.status = true;

        if (this.currentUser.company.payByInvoice === true || this.currentUser.company.enableSubscription === true) {
            retObj.status = true;
        } else {
            if (this.$security.isUndefinedOrNull(this.selectedPaymentMethod)) {
                retObj.status = false;
                if (this.creditCards.length == 0) {
                    retObj.message = "Please add a credit card to your account.";
                } else {
                    retObj.message = "Please select a payment method to pay the jobbler.";
                }
            }
        }

        return retObj;
    }

    paginate(offset) {
        var _this = this;

        _this.remain_loading_count++;

        if (offset < 1 || offset > _this.pages.length) {
            return;
        }

        _this.paginating = true;

        _this.currentPageNumber = offset;

        if (offset !== 0) {
            offset = (offset * 20 - 20);
        }

        var getInvoices = {
            method: "GET",
            url:
                _this.$env.getAPIEndPoint() +
                "jbl/v1/companies/" +
                _this.currentUser.company.id +
                "/files?format=json&conf=web&sort=id&order=desc&max=20&type=" +
                _this.fid +
                "&offset=" +
                offset,
            headers: {
                "Content-Type": "application/json",
                Authorization: "Bearer " + _this.currentUser.access_token,
            },
            data: {},
        };

        _this.$http(getInvoices).then(function (directPayArray) {
            var a = [];
            try {
                directPayArray.data.forEach(function (r) {
                    console.log("each payment");
                    console.dir(r);
                    console.dir(r.payedUser[0].email);
                    if (r.payment) {
                        a.push(r);
                    }
                });
            } catch (err) {
                console.error("we have an error");
                console.dir(err);
            } finally {
                _this.formatPaymentCost(a);
                _this.directPaymentReceiptList = a;
                _this.remain_loading_count--;

                _this.$timeout(function () {
                    _this.paginating = false;
                });
            }
        });
    }

    keepTwoDecimals() {
        var _this = this;
    }

    organizePaymentInfo() {

        var _this = this;

        console.log("organize payment info");
        console.dir(_this.paymentInfos);

        if (_this.paymentInfos) {
            if (_this.paymentInfos.length > 0) {
                try {
                    _this.paymentInfos.forEach(function (paymentInfo) {
                        if (paymentInfo.bankName && paymentInfo.validated) {
                            _this.banksArray.push(paymentInfo);
                        } else {
                            if (paymentInfo.bankName) {
                            } else {
                                _this.cardsArray.push(paymentInfo);
                            }
                        }
                    });
                } finally {
                    _this.cardsArray.forEach(function (paymentInfo) {
                        paymentInfo.cardExpirationDate =
                            moment().month(parseInt(paymentInfo.cardExpirationMonth)).format("MM") + "/" + paymentInfo.cardExpirationYear;
                    });
                }
            }
        }
    }

    formatRecDate(date) {
        return moment(date).format("MM/DD/YY");
    }

    formatPaymentInfoForPage(info) {
        var _this = this;

        console.log("formatPaymentInfoForPage");
        console.dir(info);
        _this.paymentMethodsFormatted = _this.$auth.formatPaymentMethods(info);

    }

    selectPaymentMethod(paymentMethod) {
        var _this = this;

        console.log("selectPaymentMethod");
        console.dir(paymentMethod);
        console.dir(_this.currentUser.company);

        if (paymentMethod.isChecked === true) {
            paymentMethod.isChecked = false;
        } else {
            paymentMethod.isChecked = true;
        }

        let foundPaymentMethod = false;

        try {
            this.paymentMethodsFormatted.forEach(function (method) {
                if (method.isChecked === true) {
                    foundPaymentMethod = true;
                }
            });
        } finally {

            if (foundPaymentMethod === false) {
                _this.selectedPaymentMethod = null;
            } else {
                _this.selectedPaymentMethod = paymentMethod;

                _this.paymentMethods = _this.$auth.selectPaymentMethod(_this.paymentMethods, paymentMethod);
            }
        }
    }

    formatMessageForConfirmation(receiptForDisplay, resp) {
        var _this = this;
        if (receiptForDisplay) {
            var amount = (receiptForDisplay.payment[0].amountCompany / 100).toFixed(2);
            _this.messageForModal = "$" + _this.payJobblerInfo.amount + " was transferred to " + _this.payJobblerInfo.email;
        }
    }

    validateDirectPayNotes() {
        if (this.payJobblerInfo.noteForReceipt.length > 100) {
            this.error_with_note = true;
        } else {
            this.error_with_note = false;
        }
    }

    validateDirectPayEmail() {
        var _this = this;

        ///^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
        let email =
            /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/.test(
                _this.payJobblerInfo.email
            );
        //let email = /^[a-z0-9._%+-]+@[a-z0-9.-]+\.[a-z]{2,4}$/.test(_this.payJobblerInfo.email);
        _this.validEmail = email;
        if (email === true) {
            _this.$timeout(function () {
                _this.checkUserPaymentInfo();
            }, 500);
        } else {
            _this.$timeout(function () {
                _this.error_with_email = true;
            }, 1500);
        }

        if (_this.currentUser.company.payByInvoice === true || _this.currentUser.company.enableSubscription === true) {
            _this.selectedPaymentMethod = true;
        }
    }

    checkUserPaymentInfo() {
        var _this = this;

        if (_this.validEmail) {
            _this.$auth.getUserByEmail(_this.payJobblerInfo.email).then(
                function (response) {
                    if (response.data.status === "error") {
                        _this.error_with_email = true;
                        _this.successfulEmail = false;
                    } else {
                        _this.successfulEmail = true;
                        _this.error_with_email = false;
                    }
                },
                function (error) {
                    console.log("error");
                    console.dir(error);
                }
            );
        }
    }

    getDirectPayReceipts() {
        var _this = this;

        _this.loading_invoices = true;

        _this.$companies.fileTypesReq().then(function (fileTypes) {
            try {
                for (var i = 0; i < fileTypes.data.length; i++) {
                    if (fileTypes.data[i].name === "COMPANY_INVOICE_PDF") {
                        _this.fid = fileTypes.data[i].id;
                    }
                }
            } finally {
                _this.$companies.getDirectPaymentReceipts(20, _this.fid).then(
                    function (response) {
                        var a = [];

                        try {
                            response.data.forEach(function (r) {
                                if (r.payment) {
                                    if (r.payment[0].notePayer === "Connection") {
                                        r.payedUser = [];
                                        var payedUserObj = {};
                                        payedUserObj.firstName = "Jobble";
                                        payedUserObj.email = "high-five@jobble.com";
                                        r.payedUser.push(payedUserObj);
                                    }

                                    a.push(r);
                                }
                            });
                        } finally {
                            _this.formatPaymentCost(a);
                            _this.directPaymentReceiptList = a;
                            _this.loading_invoices = false;
                            _this.remain_loading_count--;
                        }
                    },
                    function (response) {
                        _this.remain_loading_count--;
                        _this.$timeout(function () {
                            jQuery("#show-application-alert").trigger("click");
                        }, 100);
                    }
                );
            }
        });
    }

    bulkPayments(file, invalidFiles) {
        var _this = this;
        var reader = new FileReader();
        let file_as_text = reader.readAsText(file);
        reader.onload = _this.loadHandler(file_as_text);
    }

    loadHandler(text) {
        var _this = this;
    }

    handleContent(content) {
        var _this = this;
    }

    loadWorksheet(e) {
        let file = e.target.result;
        let workbook = XLSX.read(file, {type: "binary"});
        let sheetName = workbook.SheetNames[0];
        this.sheet = XLSX.utils.sheet_to_json(workbook.Sheets[sheetName]);
        this.sheet = this.cleanseKeys();
        this.validateSheet();
        this.showBulkPayTotal();
        this.$scope.$apply(); // Need this to update angular with the changes
    }

    cleanseKeys() {
        var _this = this;
        var sheet_after_cleanse = [];
        try {

            this.sheet.forEach(function (row, i) {
                let row_build = {};
                let keys = Object.keys(row);
                let values = keys.map(function (v) {
                    return row[v];
                });

                keys.forEach(function (key, x) {
                    let lower_case_key = key.toLowerCase();
                    let lower_case_key_trimmed = lower_case_key.trim();
                    let lower_case_key_trimmed_capitalized = _this.capitalizeFirstLetter(lower_case_key_trimmed);

                    key = lower_case_key_trimmed_capitalized;

                    switch (x) {
                        case 0:
                            row_build.Email = key;
                            row_build.Email = values[0].trim();
                        case 1:
                            row_build.Note = key;
                            row_build.Note = values[1];
                        case 2:
                            row_build.Amount = key;
                            row_build.Amount = values[2];
                    }
                });

                sheet_after_cleanse.push(row_build);
            });
        } catch (err) {
            console.log("catch error");
            console.dir(err);
        }
        return sheet_after_cleanse;
    }

    capitalizeFirstLetter(string) {
        return string.charAt(0).toUpperCase() + string.slice(1);
    }

    validateSheet(sheet) {
        var _this = this;

        this.sheet.forEach(function (row, i) {
            let keys = Object.keys(row);
            let values = keys.map(function (v) {
                return row[v];
            });

            if (keys.length < 3) {
                let validate_obj = _this.checkForEmptyCells(keys, row);
                if (validate_obj.status === false) {
                    _this.handleCsvError(null, validate_obj);
                    return;
                }
            }
            try {
                for (var x = 0; x < keys.length; x++) {
                    let key = keys[x];
                    let val = row[keys[x]];
                    let parent_counter = i + 1;
                    let counter = x + 1;
                    let msg = null;
                    if (val) {
                        if (key === "Email") {
                        } else if (key === "Note") {
                        } else if (key === "Amount") {
                        } else {
                            _this.handleCsvError(key);
                            break;
                        }
                    } else {
                        if (key === "Email" || key === "Amount") {
                            if (key === "Amount") {
                                if (val === 0) {
                                    msg =
                                        "One or more of the users in your spreadsheet have the 'Amount' column set to 0. We do not process payments less than .05 cents";
                                    _this.handleCsvError(key, null, msg);
                                } else {
                                    _this.handleCsvError(key, null, null);
                                }
                            } else {
                                _this.handleCsvError(key, null, null);
                            }
                            //_this.handleCsvError(key,null,msg);
                            break;
                        }
                    }
                }
            } catch (err) {
                console.log("caught an error");
                console.dir(err);
            } finally {
                console.log("in the finally of the validate");
            }
        });
    }

    checkForEmptyCells(keys, row) {
        var _this = this;
        let ret_obj = {};
        if (keys.indexOf("Amount") < 0) {
            ret_obj.status = false;
            ret_obj.text =
                "Every cell under the 'Amount' is required. Your CSV does not meet this requirement. Please click the 'View Example CSV' above to see a working sheet.";
        } else if (keys.indexOf("Email") < 0) {
            ret_obj.status = false;
            ret_obj.text =
                "Every cell under the 'Email' is required. Your CSV does not meet this requirement. Please click the 'View Example CSV' above to see a working sheet.";
        } else {
        }
        return ret_obj;
    }

    handleCsvError(key, validation_obj, msg) {
        var _this = this;
        let csv_error = {};
        if (validation_obj) {
            csv_error.text = validation_obj.text;
            _this.csv_error = csv_error;
        } else {
            if (msg) {
                csv_error.text = msg;
                _this.csv_error = csv_error;
            } else {
                csv_error.text =
                    "The column header '" +
                    key +
                    "' does not fit the accepted format. Please click 'View Example CSV' to see how the CSV file should be organized.";
                _this.csv_error = csv_error;
            }
        }
    }

    trimSheet() {
        var _this = this;
        try {
            _this.sheet.forEach(function (item) {
                if (item.Email) {
                    item.Email = item.Email.trim();
                }
                if (item.Amount) {
                    item.Amount = item.Amount.toString();
                    item.Amount = item.Amount.trim();
                }
            });
        } catch (err) {
            console.dir(err);
        } finally {
        }
    }

    submitBulkPayToggle() {
        var _this = this;
        _this.show_invalid_users = false;
        console.log("submitBulkPayTogglesubmitBulkPayTogglesubmitBulkPayTogglesubmitBulkPayTogglesubmitBulkPayToggle");
        console.dir(_this.currentUser.company);
        console.dir(_this.selectedPaymentMethod);
        if (!_this.currentUser.company.payByInvoice) {
            if (!_this.selectedPaymentMethod && (!_this.currentUser.company.enableSubscription && !_this.currentUser.company.sendInvoice)) {
                alert("Please select a payment method at the top of the page.");
                return;
            }
        }
        if (_this.selectedPaymentMethod) {
            if (_this.selectedPaymentMethod.bankName) {
                _this.bulk_pay_data.token_type = "bank";
            } else {
                _this.bulk_pay_data.token_type = "card";
            }
        }
        _this.$timeout(function () {
            $("#direct-pay-completed-bulk").modal();
        }, 300);
    }

    submitBulkPay() {

        var _this = this;

        let data = {};

        data.transfers = [];

        console.log("submitBulkPay");
        console.dir(_this.bulk_pay_data);
        console.dir(_this.selectedPaymentMethod);
        console.dir(_this.currentUser.company);

        if (!_this.currentUser.company.payByInvoice && (!_this.currentUser.company.enableSubscription && !_this.currentUser.company.sendInvoice)) {
            if (!_this.selectedPaymentMethod) {
                alert("Please select a payment method");
                return;
            } else {
                if (_this.selectedPaymentMethod.payType === "bank") {
                    data.bank = _this.selectedPaymentMethod.stripeId;
                } else {
                    if (_this.selectedPaymentMethod.stripeId) {
                        data.card = _this.selectedPaymentMethod.stripeId;
                    } else {
                        data.card = _this.selectedPaymentMethod.cardToken;
                    }
                }
            }
        } else if (_this.currentUser.company.payByInvoice === true) {
            //do nothing
        } else {
            if (_this.selectedPaymentMethod) {

                if (_this.selectedPaymentMethod.payType === "bank") {
                    data.bank = _this.selectedPaymentMethod.stripeId;
                } else {
                    if (_this.selectedPaymentMethod.stripeId) {
                        data.card = _this.selectedPaymentMethod.stripeId;
                    } else {
                        data.card = _this.selectedPaymentMethod.cardToken;
                    }
                }
            }
        }
        _this.making_bulk_pay = true;
        _this.bulk_pay_link_value = "Making Payment";

        try {
            _this.sheet.forEach(function (item) {
                let jobbler = {};
                jobbler.recipient = item.Email;
                let pay_amount = null;
                if (typeof item.Amount === "string") {
                    if (item.Amount.indexOf(".") == -1) {
                        pay_amount = parseInt(item.Amount, 10);
                    } else {
                        pay_amount = parseFloat(item.Amount);
                    }
                } else if (typeof item.Amount === "number") {
                    pay_amount = item.Amount;
                }
                jobbler.amount = Math.round(pay_amount * 100);
                jobbler.note = item.Note;
                data.transfers.push(jobbler);
            });
        } catch (err) {
            console.log("error");
            console.dir(err);
        }

        let u = _this.currentUser;

        _this.$companies.makePayment(data, u).then(
            function (response) {
                _this.handleBulkPayResponse(response);
                _this.$timeout(function () {
                    _this.bulk_pay_link_value = "Confirm";
                    _this.making_bulk_pay = false;
                }, 300);
            },
            function (error) {
                _this.making_bulk_pay = false;
            });

    }

    showBulkPayTotal() {

        var _this = this;

        let total = 0;

        try {
            _this.sheet.forEach(function (item) {

                if (typeof item.Amount === "number") {
                    total = total + item.Amount;
                } else {
                    if (item.Amount.indexOf("$") > -1) {
                        let index = item.Amount.indexOf("$");
                        item.Amount = item.Amount.substring(index + 1, item.Amount.length);
                    }
                    if (item.Amount.indexOf(".") == -1) {
                        total = total + parseInt(item.Amount, 10);
                    } else {
                        total = total + parseFloat(item.Amount);
                    }
                }
            });
        } catch (err) {
            console.log("we know there is an error");
            console.dir(err);
        } finally {
            _this.bulk_pay_data.display_amount = total * (1 + _this.currentUser.company.defaultPlan.companyFeePct);
            let bulk_pay_data_display_amount_temp = total * (1 + _this.currentUser.company.defaultPlan.companyFeePct);
            _this.bulk_pay_data.display_amount = numeral(_this.bulk_pay_data.display_amount).format("$0,0.00");
            _this.confirmation_modal_amount = _this.bulk_pay_data.display_amount;
            _this.bulk_pay_data.total = numeral(total).format("$0,0.00");
            _this.bulk_pay_data.fee = (bulk_pay_data_display_amount_temp - total).toFixed(2);
            if (_this.selectedPaymentMethod) {
                console.dir(_this.selectedPaymentMethod);
                console.dir(_this.selectedPaymentMethod.stripeId);
            }

            return _this.bulk_pay_data.display_amount;
        }
    }

    clearBulkPay() {
        var _this = this;

        _this.sheet = null;
    }

    handleBulkPayResponse(response) {
        var _this = this;
        if (response.status === 200) {
            if (response.data.status === "error") {
                _this.handleBulkPaymentError(response.data.message);
            } else {
                _this.$timeout(function () {
                    $("#direct-pay-completed-bulk").modal("toggle");
                });
                _this.$timeout(function () {
                    _this.sheet = null;
                    $("#bulk-pay-success").modal();
                    _this.getNewReceipts();
                }, 300);
            }
        } else {
            console.log("do some other error handling");
            _this.handleBulkPaymentError(response.data.message);
        }
    }

    handleBulkPaymentError(error) {
        var _this = this;

        if (error.indexOf("Cannot find user(s)") > -1) {
            let len = "Cannot find user(s)".length;
            let users = error.substring(len, error.length);
            let array_of_users = users.split(",");
            _this.cleanseInvalidUsers(array_of_users);
        } else {
            console.log("down here");
            _this.$timeout(function () {
                $("#direct-pay-completed-bulk").modal("toggle");
            });
            _this.$timeout(function () {
                $("#bulk-pay-error").modal();
                _this.bulk_error = error;
            }, 300);
        }
    }

    cleanseInvalidUsers(array_of_invalid_users) {
        var _this = this;
        let cleansed_list = [];
        try {
            array_of_invalid_users.forEach(function (user) {
                let user_trimmed = null;
                if (user) {
                    user_trimmed = user.trim();
                    if (user_trimmed.length > 0) {
                        cleansed_list.push(user_trimmed);
                    }
                }
            });
        } catch (err) {
            console.log("error");
            console.dir(err);
        }

        _this.removeInvalidUsersFromSheet(cleansed_list);
    }

    removeInvalidUsersFromSheet(invalid_users) {
        var _this = this;

        let sheet_without_invalid_user = [];
        let sheet_with_invalid_user = [];
        try {
            _this.sheet.forEach(function (row) {
                console.dir(row);
                console.dir(invalid_users.indexOf(row.Email));
                if (invalid_users.indexOf(row.Email) < 0) {
                    sheet_without_invalid_user.push(row);
                } else {
                    sheet_with_invalid_user.push(row);
                }
            });
        } catch (err) {
            console.log("error looping the sheet");
            console.dir(err);
        }
        _this.invalid_users = sheet_with_invalid_user;
        _this.sheet = sheet_without_invalid_user;
        _this.show_invalid_users = true;
    }

    getNewReceipts() {
        var _this = this;
        _this.loading_invoices = true;
        _this.$timeout(function () {
            _this.$auth.validateUserByTokenWeb(_this.currentUser.access_token).then(
                function (r) {
                    _this.$companies.getDirectPaymentReceipts(20, _this.fid).then(
                        function (response) {
                            if (response.statusText === "OK") {
                                _this.formatPaymentCost(response.data, response);
                                _this.directPaymentReceiptList = response.data;
                                _this.$timeout(function () {
                                    _this.loading_invoices = false;
                                }, 300);
                            } else {
                                _this.loading_invoices = false;
                            }
                        },
                        function (error) {
                            _this.loading_invoices = false;
                        }
                    );
                },
                function (error) {
                    console.log("error validating token");
                    console.dir(error);
                }
            );
        }, 8000);
    }

    navigateDirectPay(page) {
        var _this = this;
        if (page === "bulk-pay") {
            _this.navOptions[0].isActive = "";
            _this.navOptions[1].isActive = "active";
            _this.$state.go("bulkpay");
        } else {
            _this.navOptions[0].isActive = "active";
            _this.navOptions[1].isActive = "";
            _this.$state.go("directpay");
        }
    }

    showExampleCSV() {
        var _this = this;

        if (_this.show) {
            _this.show = false;
        } else {
            _this.show = true;
        }
    }

    getLatestInfo() {
        var _this = this;

        let t = _this.currentUser.access_token;
        _this.$auth.validateUserByTokenWeb(t).then(
            function (resp) {
                _this.currentUser = resp.data;
                if (_this.currentUser.company.totalNumberOfInvoiceFiles) {
                    var pageArray = [];
                    for (var i = 0; i < Math.ceil(_this.currentUser.company.totalNumberOfInvoiceFiles / 20); i++) {
                        pageArray.push(i + 1);
                        _this.pages = pageArray;
                    }
                }
            },
            function (error) {
                console.log("error");
                console.dir(error);
            }
        );
    }

    pullLatestPaymentInfo() {
        this.setLoader();
        this.$profiles.getPaymentInfo().then(
            (response) => {
                console.log("latest payment info?");
                console.dir(response);
                console.dir(response.data.company.undeletedPaymentInfos.length);
                this.currentUser.company.undeletedPaymentInfos = response.data.company.undeletedPaymentInfos;
                this.paymentInfos = response.data.company.undeletedPaymentInfos;
                this.formatPaymentInfoForPage(response.data.company.undeletedPaymentInfos);
                //this.organizePaymentInfo();
                this.showPaymentInfo = true;
                this.$timeout(() => {
                    this.unSetLoader();
                }, 750);
            }, (error) => {
                console.log("what is error");
                console.dir(error);
                this.showPaymentInfo = true;
                this.unSetLoader();
                alert("Error loading users payment information : " + error.status);
            });
    }

    setLoader() {
        var _this = this;
        _this.$timeout(function () {
            $("html").addClass("wait");
        });
    }

    unSetLoader() {
        var _this = this;

        _this.$timeout(function () {
            $("html").removeClass("wait");
        });
    }
}

DirectpayController.$inject = [
    "$http",
    "$localStorage",
    "$state",
    "auth",
    "events",
    "security",
    "env",
    "companies",
    "$timeout",
    "$rootScope",
    "$scope",
    "$stateParams",
    "profile"
];

export default DirectpayController;


// WEBPACK FOOTER //
// ./client/app/components/directpay/directpay.controller.js